// Partner utility functions

/**
 * Checks if a user is a partner based on their user_type
 * Partners have co_branded/white_label types OR exist in partners table
 * Sub-accounts (partner_client) are NOT partners and should go to normal app
 */
export function isPartnerUser(userType?: string | null): boolean {
  // Sub-accounts are explicitly NOT partners - they should go to normal app
  if (userType === 'partner_client') {
    return false;
  }
  
  // Check for explicit partner types in profiles table
  if (userType) {
    const normalizedType = userType.toLowerCase();
    if (normalizedType === 'co_branded' || normalizedType === 'white_label') {
      return true;
    }
  }
  
  // If user has a partner_id but is not a partner_client, they might be a partner
  // This handles cases where partner type isn't set in profiles.user_type but exists in partners table
  // We'll rely on the ProtectedRoute to make the final determination using partner details
  return false;
}

/**
 * Gets the specific partner type for a user
 * Returns the specific type (co_branded, white_label) or null if not a partner
 */
export function getPartnerType(userType?: string | null): 'co_branded' | 'white_label' | null {
  if (!userType) return null;
  
  const normalizedType = userType.toLowerCase();
  
  if (normalizedType === 'co_branded') return 'co_branded';
  if (normalizedType === 'white_label') return 'white_label';
  
  return null;
}

/**
 * Checks if a partner is a co-branded partner
 */
export function isCobranded(userType?: string | null): boolean {
  return userType?.toLowerCase() === 'co_branded';
}

/**
 * Checks if a partner is a white-label partner
 */
export function isWhiteLabel(userType?: string | null): boolean {
  return userType?.toLowerCase() === 'white_label';
}

/**
 * Checks if a user is a partner client (sub-account)
 */
export function isPartnerClient(userType?: string | null): boolean {
  return userType === 'partner_client';
}

export const generateRandomPassword = () => {
  const length = 12;
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';
  let password = '';
  // Ensure at least one character from each category
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  const symbols = '!@#$%^&*';
  password += uppercase[Math.floor(Math.random() * uppercase.length)];
  password += lowercase[Math.floor(Math.random() * lowercase.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += symbols[Math.floor(Math.random() * symbols.length)];
  
  for (let i = 4; i < length; i++) { password += charset[Math.floor(Math.random() * charset.length)]; }
  return password.split('').sort(() => Math.random() - 0.5).join('');
};